import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

const AdminLogin = () => {
  const { login, isAuthenticated } = useAuth();

  // If already authenticated, redirect to admin
  React.useEffect(() => {
    if (isAuthenticated) {
      window.location.href = '/admin';
    }
  }, [isAuthenticated]);

  const handleLogin = async () => {
    try {
      await login('Google');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-content">
        <button onClick={() => window.location.href = '/'} className="back-button-login">
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </button>

        <div className="admin-login-card">
          <div className="admin-login-icon">
            <Shield size={64} />
          </div>
          
          <h1>Admin Access</h1>
          <p className="admin-login-subtitle">
            Authorized administrators only
          </p>
          
          <div className="admin-login-info">
            <p>
              This area is restricted to Westbay Group administrators.
              Sign in with your authorized Google account to continue.
            </p>
          </div>

          <Button onClick={handleLogin} className="admin-login-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Sign in with Google
          </Button>

          <div className="admin-login-notice">
            <p>
              <strong>Note:</strong> Only accounts authorized by Westbay Group administrators will have access to the dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
